import NProgress from 'nprogress'

NProgress.configure({
  easing: 'ease',
  speed: 200,
  trickle: true,
  trickleSpeed: 500,
  showSpinner: true,
})

export default class ProgressIndicator {
  constructor () {
    this.count = 0
    this.uid = null
  }

  wrap (request) {
    return (...args) => {
      this.start()

      return request(...args)
        .then((...targs) => {
          this.done()
          return Promise.resolve(...targs)
        })
        .catch((...cargs) => {
          this.done()
          return Promise.reject(...cargs)
        })
    }
  }

  start () {
    this.count += 1
    NProgress.start()
  }

  done () {
    this.count -= 1
    NProgress.inc()

    // リクエスト終了直後に再リクエストが行われる場合、
    // 完了と開始が連続して起こり目障りなため、継続する
    setTimeout(() => {
      if (this.count === 0) {
        NProgress.done()
      }
    }, 1)
  }
}

export const progressIndicator = new ProgressIndicator()



// WEBPACK FOOTER //
// ./src/libs/progress-indicator.js